import { Chip, colors, TableCell, TableRow, Tooltip, Typography } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { LoadingIndicator, SlotTooltip } from 'components';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Link as RouterLink } from "react-router-dom";
import { Teacher } from 'services';
import truncate from 'utils/truncate';
import useErrorCatcher from "utils/useErrorCatcher";


const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  spinner: {
    marginTop: theme.spacing(3),
  },
  table: {
    border: "1px #eeeeee solid",
    overflowX: "auto"
  },
  cell: {
    border: "1px #eeeeee solid",
    flex: "1",
    display: "flex",
    minHeight: 80,
    paddingTop: 8,
    paddingRight: 8,
    flexDirection: "column",
    overflowX: "auto"
  },
  row: {
    display: "flex"
  },
  header: {
    border: "1px #eeeeee solid",
    flex: "1"
  },
  chip: {
    margin: theme.spacing(0.5)
  },
  card: {
    marginTop: theme.spacing(2)
  },
  buttons: {
    padding: theme.spacing(2),
  },
  center: {
    justifyContent: "center"
  },
  slotslider: {
    flex: 1,
    overflowX: "auto"
  },
  loading: {
    alignItems: "center"
  }

}));


let mounted = false;

const TeacherRow = props => {
  const { teacher, date, handleActivityOpen } = props;

  const [days, setDays] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const runAsyncBlock = useErrorCatcher();
  const classes = useStyles();

  useEffect(() => {
    mounted = true;
    return () => { mounted = false };
  })

  useEffect(() => {
    let new_days = [];
    let cur_date = moment(date).startOf("week");
    for (let i = 0; i < 7; i++) {
      new_days.push({ month: cur_date.month(), year: cur_date.year(), date: cur_date.date() + i, slots: [], moment: moment(cur_date).add(i, "days") });
    };
    setLoading(true);

    runAsyncBlock(async () => {
      let { models } = await Teacher.schedule(teacher.id, {
        query: {
          limit: 9999,
          range: `${moment(date).startOf("week").format("YYYY-MM-DD")}`
        }
      });
      if (mounted) {
        let new_total = 0;
        models.forEach(model => {
          new_total += model.duration;
          let the_date = moment(model.start_at);
          for (let i = 0; i < new_days.length; i++) {
            let day = new_days[i];
            if (the_date.isSame(day.moment, "day")) {
              day.slots.push(model);
              break;
            }
          }
        });
        setDays([...new_days]);
        setTotal(new_total);
      }
    }).finally(() => { mounted && setLoading(false) });
  }, [date]); // eslint-disable-line

  const get_chip_color = chip => {
    switch (chip.status) {
      case "scheduled":
        return { backgroundColor: colors.green["500"], color: "white" }
      case "concluded":
        return { backgroundColor: colors.grey["500"], color: "white" }
      case "closed":
        return { backgroundColor: colors.red["A700"], color: "white", textDecoration: "line-through" }
      default:
        break;
    }
  }

  return (
    <TableRow className={classes.row}>
      <TableCell className={clsx(classes.cell, classes.center)} align="center">
        <div><Typography variant="h4">{teacher.name_en}</Typography></div>
        <div><Typography variant="caption">{(total / 3600).toFixed(1)} hour(s)</Typography></div>
      </TableCell>
      {!loading && days.map((day, index1) => (
        <TableCell className={classes.cell} key={index1}>
          <div className={classes.slotslider}>
            {day.slots && day.slots.map((slot, index) => (
              <LightTooltip interactive key={index}
                title={
                  <SlotTooltip handleActivityOpen={handleActivityOpen} slot={slot} />
                }
                placement="right"
              >
                <Chip style={get_chip_color(slot)} clickable to={`/lesson_slots/${slot.id}/summary`} component={RouterLink} size="small" label={truncate(slot.name_en, 20)} className={classes.chip} />
              </LightTooltip>))}
          </div>
        </TableCell>
      ))}
      {loading &&
        <TableCell className={clsx(classes.cell, classes.center, classes.loading)}>
          <LoadingIndicator active />
        </TableCell>
      }
    </TableRow>
  )
}

export default TeacherRow;


const LightTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}))(Tooltip);